// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Badge from '../../../../shared/components/badge';
import Warranty from '@deere/cps-it.warranty-model-factory/lib/warranty';

const WarrantyCoverageItemRowThree = props =>
    <div className='warranty-coverage-item-row-three'>
        {props.warranty.diagnosticsCovered &&
            <Badge
                className='diagnostics-covered-badge'
                text='DIAGNOSTICS_COVERED'
                translate={true}
            />
        }
        {props.warranty.fluidSamplingRequired &&
            <Badge
                className='fluid-sampling-badge'
                text='FLUID_SAMPLING_REQUIRED'
                translate={true}
            />
        }
        {props.warranty.supplierWarranty &&
            <Badge
                className='supplier-warranty-badge'
                text='SUPPLIER_WARRANTY'
                translate={true}
            />
        }
        {props.warranty.suspended &&
            <Badge
                className='suspended-badge'
                text='SUSPENDED'
                translate={true}
            />
        }
        {props.warranty.laborApplies === false &&
            <Badge
                className='no-labor-coverage-badge'
                text='NO_LABOR_COVERAGE'
                translate={true}
            />
        }
        {props.warranty.jDProtectInspection &&
            <Badge
                className='inspection-badge'
                text='INSPECTION'
                translate={true}
            />
        }
        {props.warranty.jDProtectMCon &&
            <Badge
                className='maintenance-badge'
                clickable={props.maintenancePlanLink}
                onClick={props.onClick}
                text='MAINTENANCE'
                translate={true}
            />
        }
        {props.warranty.wearPartCoverage.amount > 0 &&
            <Badge
                className='wear-parts-badge'
                text='WEAR_PARTS'
                translate={true}
            />
        }
        {props.warranty.winterizationCov &&
            <Badge
                className='winterization-badge'
                text='WINTERIZATION'
                translate={true}
            />
        }
        {props.warranty.uptimeAssurance.amount > 0 &&
            <Badge
                className='up-time-assurance-badge'
                text='UPTIME_ASSURANCE'
                translate={true}
            />
        }
    </div>;

WarrantyCoverageItemRowThree.displayName = 'WarrantyCoverageItemRowThree';
WarrantyCoverageItemRowThree.propTypes = {
    maintenancePlanLink: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    warranty: PropTypes.instanceOf(Warranty).isRequired
};

export default WarrantyCoverageItemRowThree;



// WEBPACK FOOTER //
// ./src/product/details/components/warranty-coverage-panel/warranty-coverage-item-row-three.js